'use client';
import { Book, BookOpen, MessageCircle } from 'lucide-react';
import { useRouter } from 'next/navigation';

import { NotFound, NotFoundLink } from '@/shared/components/organisms/NotFoundComponent';
import { useTranslation } from '@/shared/hooks/useTranslation';

export default function Demo() {
  const { t } = useTranslation();
  const router = useRouter();

  const demoLinks: NotFoundLink[] = [
    {
      title: t('notFound.links.documentation.title'),
      subtitle: t('notFound.links.documentation.subtitle'),
      icon: BookOpen,
      href: '#',
    },
    {
      title: t('notFound.links.blog.title'),
      subtitle: t('notFound.links.blog.subtitle'),
      icon: Book,
      href: '#',
    },
    {
      title: t('notFound.links.contact.title'),
      subtitle: t('notFound.links.contact.subtitle'),
      icon: MessageCircle,
      href: '#',
    },
  ];

  const handleBackClick = () => {
    router.back();
  };

  const handleHomeClick = () => {
    router.push('/');
  };

  return (
    <NotFound
      errorCode={404}
      links={demoLinks}
      onBackClick={handleBackClick}
      onHomeClick={handleHomeClick}
    />
  );
}
